import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { Link, withRouter } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import { salesDeveloperPrefix } from "configs/routePrefix";
// import OrderService from "services/Seller/OrderService";
import DealsSvg from "assets/images/deals.svg"
import LeadsSvg from "assets/images/leads.svg"
import AppoinmentsSvg from "assets/images/appoinments.svg"
import "./styles.scss";
import { useSelector } from "react-redux";

const SalesDeveloperSidebarContent = (props) => {
  const AuthData = useSelector(state => state.Auth)
  const isExist = (data) => AuthData.permissions[data]
  const ref = useRef();
  const filter = useSelector(state=> state.adminFilter)
  const developer_id = filter?.developer_id || JSON.parse(localStorage.getItem('auth'))?.developer?.id

  const [orderNotifications, setOrderNotifications] = useState({});
  // const getOrderNotifications = async () => {
  //   const { data: notifications } =
  //     await new OrderService().getOrderNotifications();
  //   setOrderNotifications(notifications.data);
  // };
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName?.split('/')[2] === items[i].pathname?.split('/')[2]) {
          matchingMenuItem = items[i]
          break
        } else if(pathName === items[i].pathname){
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
    // getOrderNotifications();
  }, [props.location.pathname]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id='sidebar-menu'>
          <ul className='metismenu list-unstyled' id='side-menu'>
            <li className='menu-title'>{props.t("Menu")} </li>
            <li>
              <Link to={`${salesDeveloperPrefix}/profile`}>
                <i className="fas fa-user"></i>
                <span>Profile</span>
              </Link>
            </li>
            {isExist('view_compound') && <li className={!!filter?.compound_id ? 'mm-active' : ''}>
              <Link to={`${salesDeveloperPrefix}/compound/compound-list/${developer_id}`} className={!!filter?.compound_id ? 'active' : ''}>
                <i className='fa fa-users-cog'></i>
                <span>Manage Compounds</span>
              </Link>
            </li>}
            {isExist('manage_client') && <li>
              <Link to={`${salesDeveloperPrefix}/manage-clients`}>
                <i className='bx m-0 bx-home'></i>
                <span>Manage Clients</span>
              </Link>
            </li>}
            {isExist('manage_inventory') && <li>
              <Link to={`${salesDeveloperPrefix}/inventory`}>
                <img src={LeadsSvg} style={{ marginRight: "12px" }} />
                <span>Manage Inventory</span>
              </Link>
            </li>}
            {isExist('manage_deals') && <li>
              <Link to={`${salesDeveloperPrefix}/deals`}>
                <img src={DealsSvg} style={{ marginRight: "12px" }} />
                <span>Manage Deals</span>
              </Link>
            </li>}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SalesDeveloperSidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SalesDeveloperSidebarContent));
